/**
 * The organisation that reviews E2E submissions. Departments (and therefore the
 * department pickers in user administration) only apply to its users.
 */
export const REVIEWING_ORGANISATION = 'Inera';

export const belongsToReviewingOrg = (user) =>
  (user?.organisations || []).some(
    (org) => String(org).trim().toLowerCase() === REVIEWING_ORGANISATION.toLowerCase()
  );
